import { defineMessages } from 'react-intl';

export const addToBasketRecommendationsMessages = defineMessages({
  criteoFallback: {
    id: 'rde.criteo-products.headline-fallback',
    defaultMessage: 'Gesponserte Artikel',
  },
  prudsysFallback: {
    id: 'addToBasket.layer.rde.prudsys.headline-fallback',
    defaultMessage: 'Andere Kunden kauften auch',
  },
});
